(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-subscriber-copy]');
    if (!button) return;
    const status = button.closest('[data-subscriber-mini]')?.querySelector('[data-subscriber-copy-status]');
    if (!status) return;
    try {
      await navigator.clipboard.writeText(button.dataset.code);
      status.textContent = button.dataset.copied;
    } catch {
      status.textContent = button.dataset.failed;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["syncrband-activity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('syncrband-activity')) {
    customElements.define('syncrband-activity', class extends HTMLElement {
      connectedCallback() {
        if (this.activityController) return;
        this.activityController = new AbortController();
        this.activityIndex = 0;
        this.activityPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.activityFocused = false;
        const locale = this.dataset.locale || 'en';
        try {
          this.relativeFormatter = new Intl.RelativeTimeFormat(locale, {numeric: 'auto'});
          this.absoluteFormatter = new Intl.DateTimeFormat(locale, {dateStyle: 'medium', timeStyle: 'short'});
          this.activityRecords = JSON.parse(this.querySelector('[data-activity-records]').textContent)
            .filter(record => ['subscribe', 'cart', 'order'].includes(record.type) && Number.isFinite(Date.parse(record.time)))
            .sort((a, b) => Date.parse(b.time) - Date.parse(a.time));
        } catch { this.hidden = true; return; }
        const options = {signal: this.activityController.signal};
        this.addEventListener('focusin', () => { this.activityFocused = true; }, options);
        this.addEventListener('focusout', event => { this.activityFocused = this.contains(event.relatedTarget); }, options);
        this.renderEvent();
        this.activityTimer = setInterval(() => {
          if (document.hidden) return;
          if (!this.activityPaused && !this.activityFocused) this.activityIndex++;
          this.renderEvent();
        }, 4000);
      }
      disconnectedCallback() {
        clearInterval(this.activityTimer);
        this.activityController?.abort();
        this.activityController = null;
      }
      renderEvent() {
        const now = Date.now();
        this.activityRecords = this.activityRecords.filter(record => {
          const age = now - Date.parse(record.time);
          return age >= 0 && age < 604800000;
        });
        if (!this.activityRecords.length) { this.hidden = true; return; }
        this.hidden = false;
        this.querySelector('.syncrband-activity__heading').textContent = this.dataset.heading;
        const record = this.activityRecords[this.activityIndex % this.activityRecords.length];
        const nickname = typeof record.nickname === 'string' && /^\S{1,2}\*{3}\S?$/u.test(record.nickname)
          ? record.nickname : this.dataset.guest;
        const message = this.querySelector('.syncrband-activity__message');
        const text = (this.dataset[record.type] || '').replace('__SYNCRBAND_NAME__', nickname);
        if (message.textContent !== text) {
          message.textContent = text;
          const eventElement = this.querySelector('.syncrband-activity__event');
          eventElement.classList.remove('is-changing');
          requestAnimationFrame(() => eventElement.classList.add('is-changing'));
        }
        const ageSeconds = Math.max(0, Math.floor((now - Date.parse(record.time)) / 1000));
        const unit = ageSeconds >= 86400 ? 'day' : ageSeconds >= 3600 ? 'hour' : 'minute';
        const divisor = unit === 'day' ? 86400 : unit === 'hour' ? 3600 : 60;
        const time = this.querySelector('time');
        time.dateTime = new Date(record.time).toISOString();
        time.textContent = this.relativeFormatter.format(-Math.floor(ageSeconds / divisor), unit);
        time.title = this.absoluteFormatter.format(new Date(record.time));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
